import styled from 'styled-components';

export const Container = styled.div`
  max-width: 1000px;
  padding: 16px;
  margin: 20px auto;
  display: grid;
  place-items: center;
`;
